import { StyleSheet } from "react-native";
import { family } from "../../../../../../common";
import { mobilBrower } from "../../../../../../common/helpers";

export const styles = StyleSheet.create({
  selectButton: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#0F1143",
    borderRadius: 10,
  },
  wrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(20,20,20,0.8)",
  },

  modal: {
    backgroundColor: "white",
    borderRadius: 20,
    padding: 20,
    width: mobilBrower() ? "90%" : "50%",
  },

  closeIconButton: {
    width: 20,
    height: 20,
  },

  closeIcon: {
    width: "100%",
    height: "100%",
  },

  closeWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  image: {
    width: "100%",
    height: 200,
    marginTop: 25,
    marginBottom: 25,
  },

  text: {
    marginBottom: 15,
    textAlign: "center",
    width: "80%",
    fontSize: 18,
    marginLeft: "10%",
    fontFamily: family.effra,
    textTransform: "capitalize",
  },

  premiumButtonText: {
    color: "white",
    padding: 15,
    fontFamily: family.effra,
  },
});
